
import React, { useEffect, useState } from 'react';
import Util, { Data } from 'service/util';

import SearchableList from './SearchableList';

const getSrvDist = () => x => x.srv_dis;
const getMgtDist = () => x => x.mgt_dis;

const LocationSelect = (props) => {

  const [ls_dis,     setDistricts] = useState([]);
  const [getDistKey, setFnDistKey] = useState(getSrvDist);
  const [dictLoc,    setDictLoc  ] = useState(new Map());

  //---
  const [srv_dis, setDistrict] = useState(props.district
    || (props.all?'':Data.location[0].srv_dis)
  );
  const [location, setLocation] = useState(
    Util.loadDictLoc().get(`${props.district}${props.location}`)
    || (props.all?'':Data.location[0])
  );

  const onSetDistrict = (dist) =>
  {
    setLocation(props.all?'':dictLoc.get(dist)[0]);
    setDistrict(dist);
  }

  //------------------------------------------
  const refreshList = () => {
    let DIST = Array.from(Data.district);

    if (!props.map)
    { /* if no map */ }
    else if ( !(props.map instanceof Map) )
    { // ignore non dist map
      console.warn(`[${LocationSelect.name}] map has to be Map<district:string, location:int[]>`)
    } else {
      DIST = DIST.filter(d => props.map.has(d.cd))
    }

    // create location dictionary
    let _dictLoc = new Map();
    Data.location.reduce((r,x) => {
      let key = getDistKey(x);
      if (!r.get(key)) r.set(key, []);
      if (!props.map) {
        r.get(key).push(x);
      } else {
        let locList = props.map.get(x.srv_dis);
        if ( locList?.filter(l => l==x.srv_loc).length )
          r.get(key).push(x);
      }
      return r;
    }, _dictLoc);
    setDictLoc(_dictLoc);

    // create district list
    switch (props.by)
    {
      case 'management':
        setDistricts(Array.from(_dictLoc.keys()).map(d => ({ cd: d, name: d })));
        break;
      default:
        setDistricts(DIST.map(d => ({ ...d, name: `${d.cd} - ${d.name}` })));
        break;
    }

  }

  //------------------------------------------
  // init
  useEffect(() => {
    switch (props.by)
    {
      case 'management':
        setDistrict(location.mgt_dis);
        setFnDistKey(getMgtDist);
        break;
      default:
        setDistrict(location.srv_dis);
        setFnDistKey(getSrvDist);
        break;
    }
  }, [props.by])

  useEffect(refreshList, [props.map, getDistKey]);

  useEffect(() => {
    props.onUpdate?.(srv_dis, location.srv_loc, location);
  }, [srv_dis, location]);

  const wrap = (label, content) => {
    if (!!props.noLabel) return content;
    return (
      <label className={props.labelClass||'field'}>
        { props.titleComponent
         ?<props.titleComponent>{ label }</props.titleComponent>
         :<strong>{ label }</strong>
        }
        { content }
      </label>
    );
  }

  return (<>
    { wrap('地區',
      <select value={srv_dis} onChange={e=>onSetDistrict(e.target.value)}>
        { !!props.all && <option value="">全部</option> }
        { ls_dis.map(d =>
          <option key={d.cd} value={d.cd}>{d.name}</option>
        )}
      </select>
    )}
    { wrap('屋苑/車場',
      <SearchableList all={props.all} value={location} onChange={setLocation}
        items={dictLoc.get(srv_dis)||[]}
        filter={(l,v) => -1<`${l.srv_dis}${l.srv_loc}||${l.name_zh}||${l.name_en}`.toUpperCase().indexOf(v.toUpperCase())}
        getTitle={l => `${l.srv_dis}${l.srv_loc}`}
        getDesc={l => `${l.name_zh} ${l.name_en}`}
      />
    )}
  </>);
}

export default LocationSelect;
